
<template>
  <div class="disFlex" style="margin-top: 20px;padding: 0 20px;">
    <div class="ln-left">
      <div class="ln-grxx">
        <div class="ln-grxx-tx"><img :src="currentUser.avatarurl?(wjSrc+currentUser.avatarurl):txsrc" /></div>
        <div class="ln-grxx-xm">{{currentUser.realName}}</div>
        <div class="ln-grxx-id">{{currentUser.orgName}}</div>
      </div>
      <div class="ln-cpdh">
        <div :class="dhFlag=='2'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('2','/Learning/Mucurse')">
          <img v-if="dhFlag!='2'" src="@/assets/images/icons/mykc.png" />
          <img v-if="dhFlag=='2'" src="@/assets/images/icons/amykc.png" />
          我的课程
        </div>
        <div :class="dhFlag=='8'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('8','/Learning/Mytask')">
          <img v-if="dhFlag!='8'" src="@/assets/images/icons/xuexi.png" />
          <img v-if="dhFlag=='8'" src="@/assets/images/icons/axuexi.png" />
          学习任务
        </div>
        <div :class="dhFlag=='9'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('9','/Learning/Mykaoshi')">
          <img v-if="dhFlag!='9'" src="@/assets/images/icons/shijuan.png" />
          <img v-if="dhFlag=='9'" src="@/assets/images/icons/ashijuan.png" />
          我的考试
        </div>
        <div :class="dhFlag=='3'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('3','/Learning/WronCard')">
          <img v-if="dhFlag!='3'" src="@/assets/images/icons/ctk.png" />
          <img v-if="dhFlag=='3'" src="@/assets/images/icons/actk.png" />
          错题卡
        </div>
        <div :class="dhFlag=='4'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('4','/Learning/Historical')">
          <img v-if="dhFlag!='4'" src="@/assets/images/icons/lsjl.png" />
          <img v-if="dhFlag=='4'" src="@/assets/images/icons/alsjl.png" />
          学习记录
        </div>
        <div :class="dhFlag=='5'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('5','/Learning/Myorder')">
          <img v-if="dhFlag!='5'" src="@/assets/images/icons/order.png" />
          <img v-if="dhFlag=='5'" src="@/assets/images/icons/aorder.png" />
          我的订单
        </div>
        <div :class="dhFlag=='6'?'ln-cpdh-item active':'ln-cpdh-item'"
          @click="changeLaern('6','/Learning/Certificate')">
          <img v-if="dhFlag!='6'" src="@/assets/images/icons/zjzx.png" />
          <img v-if="dhFlag=='6'" src="@/assets/images/icons/azjzx.png" />
          证件中心
        </div>
        <div :class="dhFlag=='7'?'ln-cpdh-item active':'ln-cpdh-item'" @click="changeLaern('7','/Learning/Personal')">
          <img v-if="dhFlag!='7'" src="@/assets/images/icons/grzx.png" />
          <img v-if="dhFlag=='7'" src="@/assets/images/icons/agrzx.png" />
          个人中心
        </div>
      </div>
    </div>
    <div class="ln-right">
      <!-- <transition name="el-fade-in"> -->
        <router-view :currentUser="currentUser" :wjSrc="wjSrc"/>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Learning',
     props: ['currentUser','wjSrc'],
    data() {
      return {
        dhFlag: '2',
        mhname: 'el-zoom-in-top',
        txsrc:require('../assets/images/notxsex.png')
      }
    },
    methods: {
      changeLaern: function(dhFlag, path) {
        this.dhFlag = dhFlag;
        this.$router.push(path);
      }
    },
    components: {},
    created: function() {},
    watch: {
      dhFlag: {
        handler(old, newVal) {
          if (newVal > old) {
            this.mhname = 'el-zoom-in-top'
          } else {
            this.mhname = 'el-zoom-in-bottom'
          }
        },
      }
    }
  }
</script>


<style>
  .ln-left {
    width: 200px;
    height: 523px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
  }

  .ln-right {
    width: calc(100% - 300px);
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-left: 20px;
  }

  .ln-grxx {
    padding: 28px 0 37px 0;
    text-align: center;
  }

  .ln-grxx-tx img {
    width: 62px;
    height: 62px;
    border-radius: 50%;
  }

  .ln-grxx-xm {
    margin: 13px 0;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
  }

  .ln-grxx-id {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: center;
    color: #9a9a9a;
  }

  .ln-cpdh {}

  .ln-cpdh-item {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    text-align: left;
    padding-left: 46px;
    display: flex;
    align-items: center;
    transition: all 0.1s linear;
  }

  .ln-cpdh-item img {
    padding-right: 24px;
  }

  .ln-cpdh-item.active {
    background: #0071BA;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Learning.vue